"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var comments_service_1 = require("./comments.service");
var feed_service_1 = require("./feed.service");
var reactions_service_1 = require("./reactions.service");
var axios_1 = require("axios");
var qs_1 = require("qs");
var SocialContentService = /** @class */ (function () {
    function SocialContentService(token, groupId, contextTokenRepository, baseURL) {
        var socialApiClient = axios_1.default.create({
            baseURL: baseURL,
            headers: {
                Authorization: token,
            },
            paramsSerializer: function (params) { return qs_1.stringify(params, { allowDots: true }); },
        });
        this.feed = new feed_service_1.FeedService(groupId, contextTokenRepository, socialApiClient);
        this.comments = new comments_service_1.CommentsService(groupId, contextTokenRepository, socialApiClient);
        this.reactions = new reactions_service_1.ReactionsService(groupId, contextTokenRepository, socialApiClient);
    }
    return SocialContentService;
}());
exports.SocialContentService = SocialContentService;
//# sourceMappingURL=social-content.service.js.map